<h2 mat-dialog-title>{{ notification.title }}</h2>

<mat-dialog-content>
  <div class="meta-row">
    <span class="meta-item">
      <span class="meta-label">Date:</span> {{ formatDate(notification.createdDate) }}
    </span>
    <span class="meta-item">
      <span class="meta-label">Type:</span> {{ notification.type }}
    </span>
    <span class="meta-item priority-item" [class]="'priority-' + notification.priority.toLowerCase()">
      @if (notification.priority === 'High') {
        <span class="priority-exclamation">!</span>
      }
      <span class="meta-label">Priority:</span> {{ notification.priority }}
    </span>
    @if (isArchived && notification.readDate) {
      <span class="meta-item">
        <span class="meta-label">Read:</span> {{ formatDate(notification.readDate) }}
      </span>
    }
  </div>

  <div class="body-content">
    {{ notification.body }}
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!isArchived) {
    <button mat-button id="markReadBtn" (click)="onMarkAsRead()">Mark as Read</button>
  } @else {
    <button mat-button id="markUnreadBtn" (click)="onMarkAsUnread()">Mark as Unread</button>
  }
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>
